























import {Component, Emit, Prop, Ref, Vue} from "vue-property-decorator";
import {fas as icons} from "@fortawesome/free-solid-svg-icons";
import {BPopover} from "bootstrap-vue";
const iconNames = Object.keys(icons);

@Component({})
export default class IconPicker extends Vue {
    icons = Object.freeze(icons);
    ready = false;
    filterText = "";

    @Ref("primary-icon")
    primaryIcon!: HTMLElement;

    @Ref("icon-popup")
    iconPopup!: BPopover;

    @Prop()
    value!: string;

    get filteredIcons(): string[] {
        if (this.filterText === "") return iconNames;
        else {
            const filterText = this.filterText.toLowerCase();
            return iconNames
                .filter(i => icons[i].iconName.toLowerCase().indexOf(filterText) >= 0)
                .sort((a, b) => a.localeCompare(b));
        }
    }

    @Emit("input")
    change(newValue: string) {
        this.closePopup();
        return newValue;
    }

    closePopup() {
        this.iconPopup.$emit("close");
    }

    mounted() {
        this.ready = true;
    }
}
